module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pictures":"pictures","total":"Total {num} Items","noData":"No Data","errMsg":"No Human Face Is Detected"},"zh":{"pictures":"图片","total":"总共 {num} 条","noData":"暂无数据","errMsg":"未检测到人脸人体"}}')
  delete Component.options._Ctor
}
